import { Box, IconButton, Tooltip } from "@material-ui/core";
import { ReactNode, useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";

interface Props {
  children: ReactNode[];
}

export const SecuredField = ({ children }: Props) => {
  const [visible, setVisible] = useState(false);
  const toggleVisibility = () => setVisible(!visible);

  return (
    <>
      <Box display={"flex"} flexGrow={1} alignItems={"center"}>
        {visible ? (
          <span>{children}</span>
        ) : (
          <span>
            &bull; &bull; &bull; &bull; &bull; &bull; &bull; &bull; &bull;
          </span>
        )}
        <div style={{ paddingLeft: "1rem" }}>
          <Tooltip title={visible ? "Hide" : "Show"}>
            <IconButton onClick={toggleVisibility} size={"small"}>
              {visible ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </Tooltip>
        </div>
      </Box>
    </>
  );
};
